import React from 'react'
import PublicRoutes from '../../routes/PublicRoutes'
import { useVersionCheck } from '../../Hooks/versionCheckHook'

function App() {
	useVersionCheck()

	return (
		<div className="App">
			<PublicRoutes />
		</div>
	)
}

export default App
